
<template>
  <div v-if="formatter.config" :key="'geoJsonFormatter-' + reload">
  </div>
</template>

<script>
// components
import InputSelect from "comp/ui/InputSelect";
import GeoJson from 'geojson';

// modules
import Util from "src/util/util";

export default {
  name: "ag-geoJsonFormatter",
  components: {
    "ag-input-select": InputSelect
  },
  props: {
    disableUI: Boolean,
    formatter: Object,
    workflow: Object,
  },
  data() {
    return {
        reload: 0,
        shape: "",
        shapes: [
          { value: "point", text: "Point" }
        ],
        fields: [],
        x: {field: null, value: null},
        y: {field: null, value: null},
        z: {field: null, value: null},
        m: {field: null, value: null},
        spatialRef: {field: null, value: null}
    };
  },
  computed: {},
  watch: {},

  created() {},

  mounted() {
    this.reset();
  },

  methods: {
    // UI Events

     fieldInput_keyup(value, field) {
       this[field].value = value;
       this[field].field = null;
    },

    fieldSelect_change(value, field) {

      if(value.field == "-- None --") {
        this[field].value = null;
        this[field].field = null;
        this.reload++;
        return;
      }
      this[field].value = null;
      this[field].field = value;
    },

    // emitted Events

    // other

    reset() {
      if(this.formatter.config) {
        this.shape = this.formatter.config.shape;
        if(this.formatter.config.x)
          this.x = this.formatter.config.x;
        if(this.formatter.config.y)
          this.y = this.formatter.config.y;
        if(this.formatter.config.z)
          this.z = this.formatter.config.z;
        if(this.formatter.config.m)
          this.m = this.formatter.config.m;
        if(this.formatter.config.spatialRef)
          this.spatialRef = this.formatter.config.spatialRef;
      }
      this.setFields();
      this.reload++;
    },

    prepareForSave() {
        this.formatter.config = {};
        console.log("extend ",this.formatter);
    },

    setFields() {
      // add -- None -- to be able to blank out fields
      this.fields = {
        " ": [{
            value: { object: "", field: "-- None --" },
            text: "-- None --"
      }]};
      var inputFields = Util.getInputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(inputFields);
      Object.assign(this.fields, optionGroups);
    },
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/GeoJSONFormatter.vue